export const ReactData = [
	{
		title: "OrbitDesk",
		desc: "A global work command center and PWA for managing cross-border workflows, featuring essential tools.",
		tech: [
			"React.js",
			"Supabase",
			"PWA",
			"Context API",
			"Axios",
			"TailwindCss",
			"APIs",
		],
		gitlink: "//github.com/Pappyjay23/OrbitDesk",
		site: "//orbit-desk-vp.vercel.app",
	},
	{
		title: "Cinera",
		desc: "A premium, motion-driven movie discovery PWA.",
		tech: [
			"React.js",
			"Supabase",
			"GSAP",
			"TanStack Query",
			"Tailwind CSS",
			"PWA",
			"Axios",
			"APIs",
		],
		gitlink: "//github.com/Pappyjay23/Cinera",
		site: "//cinera-vp.vercel.app",
	},
	{
		title: "Halo",
		desc: "Premium headphone brand landing experience showcasing immersive GSAP animations, smooth scrolling, and 3D visuals.",
		tech: ["Next.js", "Three.js", "GSAP", "TailwindCss"],
		gitlink: "//github.com/Pappyjay23/Halo",
		site: "//halo-vp.vercel.app",
	},
	{
		title: "FlowBoard",
		desc: "A Jira-style task manager with drag-and-drop functionality and a dynamic board layout.",
		tech: ["React.js", "Dnd-Kit", "TailwindCss", "Context API"],
		gitlink: "//github.com/Pappyjay23/FlowBoard",
		site: "//flowboard-vp.vercel.app",
	},
];

export const VueData = [
	{
		title: "DevHire",
		desc: "An innovative platform that connects tech talents with their potential employers.",
		tech: [
			"Vue.js",
			"Pinia",
			"APIs",
			"TailwindCss",
			"Firebase",
			"Vue-Router",
			"Yup",
			"Axios",
		],
		gitlink: "//github.com/Pappyjay23/DevHire",
		site: "//dev-hire-vp.vercel.app/",
	},
	{
		title: "ArtSphere",
		desc: "A platform to showcase beautiful image collections.",
		tech: ["Vue.js", "APIs", "TailwindCss", "Firebase", "Vue-Router"],
		gitlink: "//github.com/Pappyjay23/ArtSphere",
		site: "//art-sphere-gallery.vercel.app/",
	},
	{
		title: "Mini Unsplash",
		desc: "A platform that allows you to enjoy the beauty of high-quality imagery right at your fingertips",
		tech: ["Vue.js", "APIs", "Sass", "Axios"],
		gitlink: "",
		site: "//mini-unsplash-clone.vercel.app/",
	},
];

export const ReactNativeData = [
	{
		title: "Serenify",
		desc: "A mobile app combining guided meditation and daily affirmations to inspire and uplift",
		tech: [
			"React Native",
			"Expo",
			"Expo-Router",
			"Expo-Vector-Icons",
			"Native Wind",
		],
		gitlink: "//github.com/Pappyjay23/Serenify",
		app: "//drive.google.com/uc?export=download&id=1WGhO4zmFH6C05_PY9C5CYYEUVNCNVRHJ",
	},
];
